import { render } from "./ScreenQuestionMultiSlider.vue?vue&type=template&id=79c63967&ts=true"
import script from "./ScreenQuestionMultiSlider.vue?vue&type=script&lang=ts"
export * from "./ScreenQuestionMultiSlider.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__